import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSun = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "sun one",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "ç¼ç»",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Oval 41",
					d: "M9.99992 15.4166C12.9915 15.4166 15.4166 12.9915 15.4166 9.99992C15.4166 7.00838 12.9915 4.58325 9.99992 4.58325C7.00838 4.58325 4.58325 7.00838 4.58325 9.99992C4.58325 12.9915 7.00838 15.4166 9.99992 15.4166Z",
					stroke: "",
					strokeWidth: 1.4,
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "æ¤­åå½¢",
					d: "M9.99992 2.49996C10.5752 2.49996 11.0416 2.03359 11.0416 1.45829C11.0416 0.882996 10.5752 0.416626 9.99992 0.416626C9.42462 0.416626 8.95825 0.882996 8.95825 1.45829C8.95825 2.03359 9.42462 2.49996 9.99992 2.49996Z",
					fill: ""
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "æ¤­åå½¢å¤ä»½ 8",
					d: "M16.0416 4.99996C16.6169 4.99996 17.0833 4.53359 17.0833 3.95829C17.0833 3.383 16.6169 2.91663 16.0416 2.91663C15.4663 2.91663 14.9999 3.383 14.9999 3.95829C14.9999 4.53359 15.4663 4.99996 16.0416 4.99996Z",
					fill: ""
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "æ¤­åå½¢å¤ä»½ 9",
					d: "M18.5416 11.0416C19.1169 11.0416 19.5833 10.5752 19.5833 9.99992C19.5833 9.42462 19.1169 8.95825 18.5416 8.95825C17.9663 8.95825 17.4999 9.42462 17.4999 9.99992C17.4999 10.5752 17.9663 11.0416 18.5416 11.0416Z",
					fill: ""
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "æ¤­åå½¢å¤ä»½ 10",
					d: "M16.0416 17.0833C16.6169 17.0833 17.0833 16.6169 17.0833 16.0416C17.0833 15.4663 16.6169 14.9999 16.0416 14.9999C15.4663 14.9999 14.9999 15.4663 14.9999 16.0416C14.9999 16.6169 15.4663 17.0833 16.0416 17.0833Z",
					fill: ""
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "æ¤­åå½¢å¤ä»½ 11",
					d: "M9.99992 19.5833C10.5752 19.5833 11.0416 19.1169 11.0416 18.5416C11.0416 17.9663 10.5752 17.4999 9.99992 17.4999C9.42462 17.4999 8.95825 17.9663 8.95825 18.5416C8.95825 19.1169 9.42462 19.5833 9.99992 19.5833Z",
					fill: ""
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "æ¤­åå½¢å¤ä»½ 12",
					d: "M3.95829 17.0833C4.53359 17.0833 4.99996 16.6169 4.99996 16.0416C4.99996 15.4663 4.53359 14.9999 3.95829 14.9999C3.383 14.9999 2.91663 15.4663 2.91663 16.0416C2.91663 16.6169 3.383 17.0833 3.95829 17.0833Z",
					fill: ""
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "æ¤­åå½¢å¤ä»½ 13",
					d: "M1.45829 11.0416C2.03359 11.0416 2.49996 10.5752 2.49996 9.99992C2.49996 9.42462 2.03359 8.95825 1.45829 8.95825C0.882996 8.95825 0.416626 9.42462 0.416626 9.99992C0.416626 10.5752 0.882996 11.0416 1.45829 11.0416Z",
					fill: ""
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "æ¤­åå½¢å¤ä»½ 14",
					d: "M3.95829 4.99996C4.53359 4.99996 4.99996 4.53359 4.99996 3.95829C4.99996 3.383 4.53359 2.91663 3.95829 2.91663C3.383 2.91663 2.91663 3.383 2.91663 3.95829C2.91663 4.53359 3.383 4.99996 3.95829 4.99996Z",
					fill: ""
				})
			]
		})
	})
});
export default SvgSun;
